module.exports = __webpack_public_path__ + "static/scale-model-of-riley-house-museum-in-tallahassee-florida-d0481685283ab21fcf288f74d533aee2.png";